import React from 'react';
import { GuardianSmsSettings } from '../../components/guardian/GuardianSmsSettings';

/** Guardian/student notification preferences (transactional SMS per academy). */
export default function SettingsGuardianNotificationsTab() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Notifications</h2>
        <p className="text-gray-600 dark:text-gray-400">
          Choose how this academy contacts you about lessons, bookings, and waitlists.
        </p>
      </div>
      <GuardianSmsSettings className="mt-0" />
    </div>
  );
}
